// extracted by mini-css-extract-plugin
module.exports = {"container":"Dashboard_container__3Osv9","income_expense":"Dashboard_income_expense__2GUQG"};